import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  public override firstPageLabel = '';
  public override lastPageLabel = '';
  public override nextPageLabel = '';
  public override previousPageLabel = '';
  public override itemsPerPageLabel = '';
  public override getRangeLabel = (page: number, pageSize: number, length: number): string =>
    length === 0
      ? this.translate.instant('shared.pagination.paginationRange', {
          range: '0-0',
          total: 0,
        })
      : this.translate.instant('shared.pagination.paginationRange', {
          range: `${page * pageSize + 1}-${Math.min((page + 1) * pageSize, length)}`,
          total: length,
        });

  private readonly subscription: Subscription;

  constructor(private readonly translate: TranslateService) {
    super();

    this.updateLabels();

    this.subscription = this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
      this.changes.next();
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateLabels(): void {
    this.firstPageLabel = this.translate.instant('shared.pagination.firstPage');
    this.lastPageLabel = this.translate.instant('shared.pagination.lastPage');
    this.nextPageLabel = this.translate.instant('shared.pagination.nextPage');
    this.previousPageLabel = this.translate.instant('shared.pagination.previousPage');
    this.itemsPerPageLabel = this.translate.instant('shared.pagination.itemsPerPage');
  }
}
